import type { FireflyRuntime } from "@sg-protect/federation-runtime";
import { FireflyProvider } from "@sg-protect/federation-runtime/squide";
import { syncRegionFromUrl } from "@sg-protect/runtime-config";
import { type TelemetryClient, TelemetryProvider } from "@workleap/telemetry/react";
import { AppRouter } from "./AppRouter.tsx";
import { captureUtmParamsFromUrl } from "./tracking/getUtmProperties.ts";

// Run before any router loader can redirect and drop the query string. The integration tests' navigation replay
// calls it too, so a step added here also runs there.
export function runPageLoadSteps() {
    syncRegionFromUrl();
    captureUtmParamsFromUrl();
}

export interface AppRootProps {
    telemetryClient: TelemetryClient;
    runtime: FireflyRuntime;
}

export function AppRoot({ telemetryClient, runtime }: AppRootProps) {
    return (
        <TelemetryProvider client={telemetryClient}>
            <FireflyProvider runtime={runtime}>
                <AppRouter />
            </FireflyProvider>
        </TelemetryProvider>
    );
}
